import { render, staticRenderFns } from "./country.vue?vue&type=template&id=22f96bb8&scoped=true&"
import script from "./country.vue?vue&type=script&lang=js&"
export * from "./country.vue?vue&type=script&lang=js&"
import style0 from "./country.vue?vue&type=style&index=0&id=22f96bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f96bb8",
  null
  
)

export default component.exports